import { ethers } from 'ethers';
import logo from '../assets/casa.png';

const Navigation = ({ account, setAccount }) => {
    const connectHandler = async () => {
        const accounts = await window.ethereum.request({ method: 'eth_requestAccounts' });
        const account = ethers.utils.getAddress(accounts[0])
        setAccount(account);
    }

    return (
        <nav>
            <ul className='nav__links'>
                <li><a href="https://sites.google.com/view/hackathon1q2023fantombnb/fantombnb?authuser=0" rel="noreferrer" target={'_blank'}>About</a></li>
                
            </ul>

            <div className='nav__brand'>
                <img src={logo} alt="Logo" />
                <h1>FantomBNB</h1>
            </div>

            {account ? (
                <button
                    type="button"
                    className='nav__connect'
                >
                    {account.slice(0, 6) + '...' + account.slice(38, 42)}
                </button>
            ) : (
                <button
                    type="button"
                    className='nav__connect'
                    onClick={connectHandler}
                >
                    Connect
                </button>
            )}
        </nav>
    );
}

export default Navigation;